// redux/importReseller/Slice.ts

import { createSlice } from '@reduxjs/toolkit';
import { REDUCER_NAME, IImportResellerState } from './Types';
import { getResellerSubscriptionList } from './ThunkAction';

const initialState: IImportResellerState = {
  isLoading: false,
  resellerList: [],
  error: null,
};

const importResellerSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    clearImportResellerState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getResellerSubscriptionList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getResellerSubscriptionList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.resellerList = action.payload?.data ?? [];
      })
      .addCase(getResellerSubscriptionList.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          (action.payload as any) ?? {
            message: 'Failed to fetch reseller subscription list',
          };
      });
  },
});

export const { clearImportResellerState } = importResellerSlice.actions;
export default importResellerSlice.reducer;
